import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig';

const environment = import.meta.env.MODE;

export default {
    stylePreviewPath:
        environment === LOCAL ? `/public/img/textToImage/styles/` : `/app/ai-tools/img/textToImage/styles/`,
    stylesJsonPath:
        environment === LOCAL
            ? `/public/preloadData/textToImage/textToImageStyles.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/textToImage/textToImageStyles.json?v=${FJVersionConfig.staticPathVersion}`,
    inspireListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/textToImage/textToImageInspireList.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/textToImage/textToImageInspireList.json?v=${FJVersionConfig.staticPathVersion}`,
    presetImageListJsonPath:
        environment === LOCAL
            ? `/public/preloadData/textToImage/textToImagePresetImage.json?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/preloadData/textToImage/textToImagePresetImage.json?v=${FJVersionConfig.staticPathVersion}`,
    presetImagePreviewPath:
        environment === LOCAL ? `/public/img/textToImage/presetImg/` : `/app/ai-tools/img/textToImage/presetImg/`,
    resultImageKey: 'ai/export/text2img/',
    originalImageKey: 'ai/input/text2img/',
    historyListType: 6,
    freeLimitType: 'text-to-image',
    currentMenuName: 'ai-text-to-image',
};
